import ListUsers from "../views/ListUsers.vue";

export default [
  {
    path: "/users",
    component: ListUsers,
    meta: { requiresAuth: true, permissions: "users,list_users" },
  },
];
